import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance, SingleValueProps} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectProps} from "@/components/select/Select.types.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";

const ServerOption = ({data, ...props}: OptionProps<MonitoringServer>) => {
  const flag = data.country.toLowerCase();
  return (
    <components.Option {...props} data={data}>
      <span className="d-flex justify-content-between">
        <span className="me-3">
          {flag && <span className={`me-2 fi fi-${flag}`} />}
          {data.is_private ? "Private" : data.location}
        </span>
        <span>{data.name}</span>
      </span>
    </components.Option>
  );
};

const SingleValueComponent = ({children, data, ...props}: SingleValueProps<MonitoringServer>) => {
  const flag = data.country.toLowerCase();
  return (
    <components.SingleValue {...props} data={data}>
      {flag && <span className={`me-2 fi fi-${flag}`} />}
      {children}
    </components.SingleValue>
  );
};

export const MonitoringServerSelect = forwardRef(
  (props: SelectProps<MonitoringServer>, ref: ForwardedRef<SelectInstance<MonitoringServer>>) => {
    return (
      <Select
        ref={ref}
        getOptionLabel={(monitoringServer) => monitoringServer.name}
        getOptionValue={(monitoringServer) => monitoringServer.id.toString()}
        components={{SingleValue: SingleValueComponent, Option: ServerOption}}
        {...props}
      />
    );
  }
);
